export const MINIMUM_DAYS_TO_SHOW_BANK_STATEMENT_MODAL = 2;
export const MAXIMUM_DAYS_BEFORE_SHOWING_WARNING = 5;
export const MAXIMUM_FUNDING_AMOUNT = 100_000;
export const ACH_DEBIT_AVERAGE_MIN_DAYS = 5;
export const ACH_DEBIT_AVERAGE_MAX_DAYS = 6;
